var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Estructura","subtitle":"Lista de actividades","fields":_vm.fields,"endpoint":_vm.endpoint,"delete":_vm.DELETE_STRUCTURE},on:{"edit":function($event){return _vm.editItem($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }